import * as React from 'react';
import { cn } from '@/utils';

const ScrollArea = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, children, ...props }, ref) => (
	<div ref={ref} className={cn('relative overflow-auto', className)} {...props}>
		{children}
	</div>
));
ScrollArea.displayName = 'ScrollArea';

type ScrollBarProps = React.HTMLAttributes<HTMLDivElement> & {
	orientation?: 'horizontal' | 'vertical';
};

const ScrollBar = React.forwardRef<HTMLDivElement, ScrollBarProps>(({ className, orientation = 'vertical', ...props }, ref) => {
	const isVertical = orientation === 'vertical';
	return (
		<div
			ref={ref}
			data-orientation={orientation}
			className={cn(
				'pointer-events-none select-none',
				isVertical ? 'absolute right-0 top-0 h-full w-2' : 'absolute bottom-0 left-0 h-2 w-full',
				className,
			)}
			{...props}
		/>
	);
});
ScrollBar.displayName = 'ScrollBar';

export { ScrollArea, ScrollBar };
